module.exports = __webpack_public_path__ + "fd8ee53d8739a70be4351642ad6d9ab5.svg";